import React, {Component} from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as NAVACTIONS from '../../actions/Navigation';

import * as Breakpoints from '../../utils/Breakpoints';

import { 
  NavLink  
} from 'react-router-dom';


class Navigation extends Component {

   constructor(props) {
	    super(props);

	    this.state = {}

   }

   componentDidMount() {
    this.props.fetchNavigation();
  }

  render () {

  	const { navigation, loading } = this.props; 

  	if(loading) return null;


    const nav1 = navigation.map((p, ix) => { 

      let navText = (p.navText != "") ? p.navText : p.title;

      if(p.nav == "NavOne" ) {
        

        return(
            <li key={ix}>
              <NavLink 
                to={'/'+p.uri+'/'} 
                isActive={(match, location) => location.pathname == "/"+p.uri}
                activeClassName={'is-active'}
              >
              {navText}
              </NavLink>
            </li>
        );
      }
    });

    const nav2 = navigation.map((p, ix) => { 
      
      if(p.nav == "NavTwo" ) {

        return(
            <li key={ix}>
              <NavLink 
                to={'/'+p.uri+'/'} 
                isActive={(match, location) => location.pathname == "/"+p.uri}
                activeClassName={'is-active'}
              >
              {p.title}
              </NavLink>
            </li>
        );
      }
    });

    return (

        
        <div className={"Navigation  Navigation--"+this.props.modifier}>

          <div className="Navigation-containers">
            
            <div className="Navigation-container  Navigation-container--1">
                <ul className="List  List--nav">
                  { nav1 }     
                </ul> 
            </div>

            <div className="Navigation-container  Navigation-container--2">
              <ul className="List  List--nav">
                  { nav2 }     
              </ul> 
            </div>

          </div>

        </div>
    
    )
  }

}

const mapStateToProps = state => ({
  navigation: state.navigation.data,
  loading: state.navigation.loading
})


const mapDispatchToProps = (dispatch) => {

  return{
  
      fetchNavigation: bindActionCreators(NAVACTIONS.getNavigation, dispatch),
  
  }
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/js/components/Navigation/Navigation.jsx